module.exports = __webpack_public_path__ + "img/taxservice.996b2022.png";